import { render, staticRenderFns } from "./MaterialIndex.vue?vue&type=template&id=4c9cc2b4"
import script from "./MaterialIndex.vue?vue&type=script&lang=js"
export * from "./MaterialIndex.vue?vue&type=script&lang=js"
import style0 from "./MaterialIndex.vue?vue&type=style&index=0&id=4c9cc2b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports